import Dexie from 'dexie'

export const db = new Dexie('fp')

db.version(1).stores({
  boards: 'id, insertOrder',
  briefs: 'id, insertOrder',
  folders: 'id, insertOrder',
  libraryAds: 'id, insertOrder',
  paginationKeys: 'id, insertOrder',
  spyderAnalytics: 'pageId, insertOrder',
  spyders: 'id, insertOrder',
  teamLibraryAds: 'id, insertOrder',
  uniqueCreatives: 'assetUrl, insertOrder'
})

db.version(2).stores({
  boards: 'id, insertOrder',
  briefs: 'id, insertOrder',
  folders: 'id, insertOrder',
  libraryAds: 'id, insertOrder',
  paginationKeys: 'id, insertOrder',
  spyderAnalytics: 'pageId, insertOrder',
  spyders: 'id, insertOrder',
  teamLibraryAds: 'id, insertOrder',
  uniqueCreatives: 'assetUrl, insertOrder',
  uniqueHooks: 'hookText'
})

export default db;
